<template>
  <transition name="slide-fade">
    <div class="page page-your-kits mt-md-5" v-if="user">
      <div class="container">
        <header>
          <div class="row mb-0">
            <div class="col-12 col-md-8 order-1 order-md-0">
              <h1>
                <span>My Sampling Kits</span>
              </h1>
            </div>
            <div class="col-12 col-md-4 mt-4 mb-3 order-0 order-md-1">
              <div class="row">
                <!--<div class="col-4 text-right">-->
                  <!--<router-link  v-if="subscriptionActive" to="profile" class="toggleSubItem">Details</router-link>-->
                <!--</div>-->
                <div class="col-8 offset-4" id="subButton">
                  <a id="activateButton" class="toggleSwitch" :class="subscriptionClass" @click.prevent="toggleSubscription">
                    <div class="toggle"><i class="fas fa-sync-alt"></i></div>
                    <span v-html="subscriptionText"></span>
                  </a>
                </div>
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-12">
              <div class="page-description">
                Welcome to the start of your journey to understanding how your microbiome affects your health. In this section of the portal, you can keep track of your results and order further kits to monitor your microbiome as part of your overall health and wellbeing.
              </div>
            </div>
          </div>


          <div id="helpCards" class="row mt-4">
            <div class="col-lg-3 col-12 mb-2">
              <QuestionCard
                question="When should I take my sample?"
                answer="If you are interested in learning about your “normal” gut microbiome, it is best to collect a sample at a time when you have maintained your regular daily habits and diet for at least two weeks prior to sampling. Changes to your normal habits such as overseas travel, short-term use of supplements, changes to exercise habits and eating new foods can impact your gut microbiome. It is also important to try and collect a sample from a bowel movement that is typical for you. Do not open the tube until you are ready to take your sample."
                link="Read more"
                image="SamplingKit-When-should-I-take.jpg"
                colour="#374A66"></QuestionCard>
            </div>
            <div class="col-lg-3 col-12 mb-2">
              <QuestionCard
                question="How do I take my sample?"
                answer="Before taking your sample, make sure you are using the kit addressed to you. Do not open the tube until you are ready to take the sample - it’s important that the swab does not come into contact with any others surfaces, as this can interfere with the sample. You should use a piece of freshly soiled toilet paper for the sample - only a small smear is needed. Detailed instructions with a visual guide are included in the kit to help you correctly gather a viable sample for the lab to process. The swab should be placed immediately back in the tube without touching any other surfaces."
                link="Read more"
                image="SamplingKit-How-do-I-take.jpg"
                colour="#665687"></QuestionCard>
            </div>
            <div class="col-lg-3 col-12 mb-2">
              <QuestionCard
                question="What happens to my sample in the lab?"
                answer="Once received in the lab, it takes 4-6 weeks to process and analyse your sample. Metagenomic sequencing provides a clear picture of your gut microbiome because it sequences all genes from the microorganisms in the sample. This high resolution (species-level) view of the bacteria, archaea, and even fungi and protists present in the sample and what these microorganisms are capable of is analysed to generate meaningful insights into your unique microbiome. You can track the progress of your sample in the My Kits tab of the Microba Discovery Portal. We will also update you with emails along the way, including when your sample is received and your results are ready to view online."
                link="Read more"
                image="SamplingKit-What-is-involved.jpg"
                colour="#0078A9"></QuestionCard>
            </div>
            <div class="col-lg-3 col-12 mb-2">
              <QuestionCard
                question="How often should I test to monitor my microbiome?"
                answer="As new connections between the gut microbiome and general health are constantly being discovered, understanding how your unique microbiome changes over time and how it affects your health can provide valuable insights as part of monitoring your overall health and wellbeing. Everyone is different when it comes to their reason for testing their microbiome, so there is no single recommendation on how often to retest. We offer a variety of subscription options to cater for regular retesting across various timeframes."
                link="Read more"
                action="See subscription options"
                image="SamplingKit-How-often-should-I-test.jpg"
                colour="#006470"
                @close="showSubscriptionModal = true"></QuestionCard>
            </div>
          </div>

        </header>

        <div class="gray-tabs">
        <b-tabs pills v-model="activeTab">
          <b-tab title="Kits in My Journey" active>

            <ul class="list-group">
              <KitItem v-if="kits" v-for="kit in kits" :kit="kit" :key="kit.id"
                      :showCoach="true"
                      :showReferralCode="true"
                      :allowGive="true"
                      @onClickRedeem="onClickRedeem(kit.id)"
                      @onClickActivate="onClickActivate(kit.id)"
                      @onClickRequest="onClickRequest(kit.id)"
                      @onClickGive="onClickGive(kit.id)"
                      @onClickBook="onClickBook(kit.id)"
                      @onClickReplacement="onClickReplacement(kit.id)"
                      @onClickCoachInfo="showCoachInfoModal = true" />
              <LoadingKitItem v-if="orderProcessing" />
              <NoKits v-if="kits.length < 1" />
            </ul>


            <div id="actionBtnRow" class="row" >
              <div class="col-12 col-md-4 mb-2">
                <a class="btn-card grey" href="#" @click.prevent="showOrderModal = true">
                  <div>
                     <div class="fa-stack mb-2">
                      <i class="far fa-circle fa-stack-2x"></i>
                      <i class="fa fa-plus fa-stack-1x"></i>
                    </div>
                    Buy a kit for my journey


                  </div>
                </a>
              </div>
              <div class="col-12 col-md-4 mb-4" >
                <a class="btn-card green" href="#" @click.prevent="openDescription" :class="{ 'btn-card-disabled' : subscriptionActive }">
                  <div>
                     <div class="fa-stack mb-2">
                      <i class="far fa-circle fa-stack-2x"></i>
                      <i class="fa fa-sync-alt fa-stack-1x"></i>
                    </div>
                    Subscribe for regular testing
                  </div>
                </a>
              </div>
              <div class="col-12 col-md-4 mb-2">
                <a @click.prevent="openRedeemModal" class="btn-card purple" href="">

                  <div>
                    <div class="fa-stack mb-2">
                      <i class="far fa-circle fa-stack-2x"></i>
                      <i class="fa fa-plus fa-stack-1x"></i>
                    </div>
                    Enter a Voucher Code
                  </div>
                </a>
              </div>
            </div>


            <!--<ul class="list-group buy-buttons" v-if="user">-->
              <!--<div class="list-group-item">-->
                <!--<div class="row">-->
                  <!--<div class="col-12 col-lg-4 mb-3">-->

                    <!--<a class="btn btn-primary btn-block" href="#" @click.prevent="showOrderForMe">Buy a kit for My Journey </a>-->
                    <!--&lt;!&ndash;<PaymentButton className="btn btn-primary btn-block" :label="addKitText" :giveAway="false" :product="additionalKit" modalHeading="Add to my journey" modalTitle="Confirm shipping & payment" modalCopy="Please confirm your details below" />&ndash;&gt;-->
                  <!--</div>-->
                  <!--<div class="col-12 col-lg-4 mb-3">-->
                    <!--<a class="btn btn-outline-info btn-block" href="#" @click.prevent="showOrderForSomeone">Buy a kit for someone else </a>-->
                  <!--</div>-->
                  <!--<div class="col-12 col-lg-4 mb-3">-->
                    <!--<button class="btn btn-primary btn-block" v-on:click="showRedeemModal = true">Redeem a kit</button>-->
                  <!--</div>-->
                <!--</div>-->
              <!--</div>-->
            <!--</ul>-->

          </b-tab>
          <b-tab title="Kits Given to Others">
              <SentKitItem v-if="kits" v-for="kit in sentKits" :kit="kit" :key="kit.kitId"  @onClickSend="onClickSend(kit.kitId)" />
              <LoadingKitItem v-if="orderProcessing" />
              <NoKits v-if="kits.length < 1" />
          </b-tab>
        </b-tabs>
        </div>

      </div>

      <b-popover :show.sync="showSubscriptionPopover" placement="bottom" target="subButton" >
        <div style="width:190px; text-align:center; color: #00193D; font-size: 14px;	line-height: 22px; padding:12px;">
          You can update or manage
          your subscriptions through
          the ‘My Profile’ page
        </div>
        <div style="text-align:center; width:190px; padding:8px 0 12px 0; font-size: 16px; ">
          <router-link to="profile" style="	color: #339795;">Go to My Profile</router-link>
        </div>
      </b-popover>

      <ModalSendAKit :kitID="selectedKit" :show="showSendModal" @close="showSendModal = false" />
      <!--<ModalActivateAKit :kitID="selectedKit" :show="showActivatModal" @close="showActivatModal = false" />-->
      <ModalActivate :kitID="selectedKit" :slide="activatePage" :show="showActivatModal" @close="showActivatModal = false" />
      <ModalRedeemAKit :kitID="selectedKit" :slide="activatePage" :show="showRedeemModal" :activateModal="showActivatModal" @close="showRedeemModal = false" />
      <ModalBooking :kitID="selectedKit" :show="showBookingModal" @close="showBookingModal = false" />
      <ModalCoachInfo :show="showCoachInfoModal" @close="showCoachInfoModal = false" className='no-padding'/>

      <ModalOrder
        :show="showOrderModal"
        :product="additionalKit"
        :giveAway="showGiveModal"
        :showIntro="false"
        heading=""
        title="Confirm your details"
        copy="Please confirm your details below"
        @close="showOrderModal = false"
        />

      <ModalSubscription
        :show="showSubscriptionModal"
        :product="additionalKit"
        heading=""
        @close="showSubscriptionModal = false"
      />

      <h1 v-if="orderProcessing">LOADING</h1>
    </div>
  </transition>
</template>

<script>
import KitItem from '@/components/elements/KitItem'
import SentKitItem from '@/components/elements/SentKitItem'
import NoKits from '@/components/elements/noKits'
import LoadingKitItem from '@/components/elements/LoadingKitItem'
import { StripeCheckout, Bus } from 'vue-stripe'
import PurchaseKit from '@/mixins/purchaseKits'
import ModalActivate from '@/components/models/ModalActivate'
import ModalSendAKit from '@/components/models/ModalSendAKit'
import ModalActivateAKit from '@/components/models/ModalActivateAKit'
import ModalRedeemAKit from '@/components/models/ModalRedeemAKit'
import ModalBooking from '@/components/models/ModalBooking'
import ModalOrder from '@/components/models/ModalOrder'
import ModalSubscription from '@/components/models/ModalSubscription'
import ModalCoachInfo from '@/components/models/ModalCoachInfo'
import PaymentButton from '@/components/elements/PaymentButton'
import QuestionCard from '@/components/elements/QuestionCard'
import _ from 'lodash'

export default {
  mixins: [ PurchaseKit ],
  components: {
    KitItem,
    SentKitItem,
    NoKits,
    LoadingKitItem,
    ModalSendAKit,
    ModalRedeemAKit,
    ModalActivateAKit,
    ModalBooking,
    PaymentButton,
    ModalCoachInfo,
    ModalOrder,
    ModalActivate,
    Bus,
    ModalSubscription,
    QuestionCard,
    'stripe-checkout': StripeCheckout
  },
  data: () => {
    return {
      activeTab: 0,
      activatePage: '',
      showSubscriptionPopover: false,
      showSendModal: false,
      showActivatModal: false,
      showRedeemModal: false,
      showOrderModal: false,
      showGiveModal: false,
      showBookingModal: false,
      showCoachInfoModal: false,
      showReplacementModal: false,
      showSubscriptionModal: false,
      selectedKit: '',
      replacementKitProduct: {
        amount: Number(process.env.PRICE_REPLACEMENT_KIT) || 30.00,
        label: '1 Microba insight kit',
        orderType: 'REPLACEMENT'
      },
      additionalKit: {
        amount: Number(process.env.PRICE_NEW_KIT) || 419.00,
        label: '1 Microba insight kit',
        orderType: 'NEW'
      },
      selectedProduct: this.tempProduct
    }
  },
  mounted: function () {
    this.$store.dispatch('getUser')
    this.$store.dispatch('getUserKits')
    this.$store.dispatch('getUserSubscription')
    this.$store.dispatch('getSentKits')
  },
  computed: {
    openDescription () {
      if (!this.subscriptionActive) {
        this.showSubscriptionModal = true
      }
    },
    subscriptionActive () {
      let subscriptions = this.$store.state.GET_SUBSCRIPTIONS_RESPONSE || []
      return _.find(subscriptions, (x) => { return x.cancelledDate === null && x.consumerUserId === this.user.id })
    },
    subscriptionText () {
      if (this.subscriptionActive) {
        return 'Subscription active'
      }
      return 'Activate subscription'
    },
    subscriptionClass () {
      if (this.subscriptionActive) {
        return 'active'
      }
      return 'inactive'
    },
    loading: function () {
      return this.$store.state.GET_KITS_PENDING
    },
    kits: function () {
      return this.$store.state.GET_KITS_RESPONSE || []
    },
    sentKits: function () {
      return this.$store.state.GET_SENT_KITS_RESPONSE || []
    },
    user: function () {
      return this.$store.state.GET_USER_RESPONSE
    },
    orderProcessing: function () {
      return false // this.$store.state.processing.order
    },
    addKitText: function () {
      return 'Buy a kit for my journey'
    },
    selectedKitId () {
      return this.selectedKit.kitId
    }
  },

  methods: {
    toggleSubscription () {
      if (this.subscriptionActive) {
        this.showSubscriptionPopover = !this.showSubscriptionPopover
      } else {
        this.showSubscriptionModal = true
      }
      // this.subscriptionActive = !this.subscriptionActive
    },
    showOrderForMe () {
      this.showGiveModal = false
      this.showOrderModal = true
    },
    showOrderForSomeone () {
      this.showGiveModal = true
      this.showOrderModal = true
    },
    onClickRedeem: function (kitID) {
      this.selectedKit = kitID
      this.showRedeemModal = true
    },
    onClickSend: function (kitID) {
      this.selectedKit = kitID
      this.showActivatModal = true
    },
    onClickGive: function (kitID) {
      this.selectedKit = kitID
      this.showSendModal = true
    },
    openRedeemModal () {
      this.activatePage = 'REDEEM_CODE_WITH_ADDRESS'
      this.showRedeemModal = true
    },
    onClickRequest: function (kitID) {
      this.selectedKit = kitID
      this.activatePage = 'REDEEM_CODE_WITH_ADDRESS'
      this.showActivatModal = true
    },
    onClickActivate: function (kitID) {
      this.selectedKit = kitID
      this.showActivatModal = true
    },
    onClickBook: function (kitID) {
      this.selectedKit = kitID
      this.showBookingModal = true
    },
    onClickReplacement: function (kitID) {
      this.selectedKit = kitID
      this.showReplacementModal = true
    },
    showPurchaseModal: function (product) {
      this.selectedProduct = product
      this.showOrderModal = true
    }
  },

  name: 'yourKits'
}
</script>

<style scoped lang="scss">

  .toggle{
    text-align: center;
    font-size: 19px;
    line-height: 36px;
    color: #339795;
  }

  .toggleSubItem{
    display:block;
    font-size:16px;
    margin-top:10px;
    margin-bottom:20px;
    color: #339795;
  }

  .toggleSwitch{
    float:right;
    width:220px;
    height:45px;
    border-radius: 25px;
    cursor:pointer;
    position:relative;;

    display: flex;
    flex-direction: row;
    align-items: center;

    .toggle{
      height: 35px;
      width: 35px;
      border-radius: 50%;
      background-color:#fff;
    }

    &.inactive{
      background: #cfd1dd;

      .toggle{
        position:absolute;
        left: 8px;
      }

      span{
        text-align: right;
        padding-right:20px;
      }
    }

    &.active{
      background: #339795;

      .toggle{
        position:absolute;
        right: 8px;
      }

      span{
        text-align: left;
        padding-left:20px;
      }


    }

    span{
      color: #fff;
      width: 100%;
      font-size:16px;
      font-weight: 400
    }
  }

  @media (min-width:992px) {
    #actionBtnRow {
      padding-left: 100px;
      padding-right: 100px;
    }
  }

.list-group{
  margin-bottom: 2rem;
}
.list-group-item{
  padding-bottom: 0.5rem;
}

.page-description {
  color: #00193D;
  font-size:1rem;
}
.buy-buttons .list-group-item{
  background: #EEF0F2;
}
.buy-buttons .list-group-item .row{
max-width: 860px;
margin: 0px auto;
}


</style>



// WEBPACK FOOTER //
// src/application/customer/YourKits.vue